exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /home/ec2-user/Source/aws-lex-web-ui/node_modules/core-js/library/modules/_object-gops.js
// module id = 108
// module chunks = 0